



















































































































import Vue from 'vue'
import Item from '@/components/Item.vue'
// import SkeletonItem from '@/components/SkeletonItem.vue'
import DescriptionElement from '@/components/DescriptionElement.vue'
import VideoModal from '@/components/VideoModal.vue'
import SlideShowMedia from '@/components/SlideShowMedia.vue'
import { getCategory } from '@/api/product'
import { ICategory, IMedia, IProduct, IProductListRequest } from '@/interfaces/product'
import CategoryListBar from '@/components/CategoryListBar.vue'
import InfiniteLoading from 'vue-infinite-loading'
import { MetaInfo } from 'vue-meta'
import moment from 'moment'

interface ISlogan {
  content: string;
  type: number;
}

export default Vue.extend({
  name: 'Home',
  components: { CategoryListBar, Item, DescriptionElement, VideoModal, SlideShowMedia, InfiniteLoading },
  data () {
    return {
      currentCategoryId: NaN,
      categoryList: [] as Array<ICategory>,
      itemsList: new Array<IProduct>(),
      nextProductIdList: '',
      slideShowMedia: [] as Array<IMedia>,
      isLoading: true,
      sloganElement: null as ISlogan | null,
      sloganUrl: null as string | null,
      infiniteId: new Date() as Date,
      scriptJsonLdObject: [] as any[]
    }
  },
  computed: {
    screenAspectRatio (): number {
      return window.screen.width / window.screen.height
    },
    isWideScreen (): boolean {
      return this.screenAspectRatio >= 1
    },
    simulateGrowthOfReviews (): number {
      const startDay = moment('2021-01-01')
      const diff = moment().diff(startDay, 'days')
      return Math.ceil(50 + (diff * 0.5))
    }
  },
  metaInfo (): MetaInfo {
    return {
      script: this.scriptJsonLdObject
    }
  },
  watch: {
    '$route.query.category': {
      handler: function (value) {
        this.currentCategoryId = value || ''
        this.initializeProducts()
      },
      immediate: true
    }
  },
  created () {
    this.$on('loadData', () => {
      this.initializeProducts()
    })
  },
  methods: {
    loadProductJsonLd () {
      this.scriptJsonLdObject = []
      this.itemsList.forEach(item => {
        const priceText = item.price_text || '0'
        const numberPattern = /\d+/g
        const result = priceText.match(numberPattern)
        let price
        if (result !== null) { price = parseInt(result[0]) } else { price = 0 }
        this.scriptJsonLdObject.push({
          type: 'application/ld+json',
          json: {
            '@context': 'http://www.schema.org',
            '@type': 'product',
            brand: 'nuPhoto 拍立洗',
            name: item.title,
            image: item.media.url,
            description: item.title + '，' + item.price_text,
            aggregateRating: {
              '@type': 'aggregateRating',
              ratingValue: '5',
              reviewCount: (item.title.length + this.simulateGrowthOfReviews).toString()
            },
            offers: {
              '@type': 'offer',
              availability: 'https://schema.org/InStock',
              price,
              priceCurrency: 'TWD',
              url: `${process.env.VUE_APP_HOST}${process.env.VUE_APP_PATH}/product/${item.product_id}`
            }
          }
        })
      })
    },
    initializeProducts () {
      this.itemsList = []
      this.$store.commit('SET_FOOTER', false)
      this.infiniteId = new Date()
      this.nextProductIdList = ''
    },
    async handleLoadProducts () {
      this.isLoading = true
      try {
        const requestBody = {
          category_id: this.currentCategoryId,
          next_product_ids: this.nextProductIdList
        } as IProductListRequest
        const { data } = await getCategory(requestBody)
        if (data.flag === 1) {
          this.$bvModal.msgBoxOk(`載入資料失敗，${data.msg}`, {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          })
        } else if (data.flag === 0) {
          const payload = data.data
          if (payload === undefined) { throw new Error('資料欄位錯誤') }
          this.itemsList = this.itemsList.concat(payload.product_list.content)
          this.sloganElement = { content: payload.slogan, type: 1 }
          this.sloganUrl = payload.slogan_url
          this.nextProductIdList = payload.product_list.next_product_ids
          if (this.slideShowMedia.length === 0) {
            if (this.isWideScreen) {
              this.slideShowMedia = payload.pc_slide_show_media
              if (this.slideShowMedia.length === 0) {
                this.slideShowMedia = payload.slide_show_media
              }
            } else {
              this.slideShowMedia = payload.slide_show_media
            }
          }
          this.loadProductJsonLd()
          this.isLoading = false
          this.$store.commit('SET_FOOTER', true)
          return Promise.resolve(this.nextProductIdList.length)
        }
      } catch (error) {
        console.error(error)
        this.$store.commit('SET_FOOTER', true)
        this.$bvModal.msgBoxOk(error.message, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        }).then(() => {
          if (process.env.NODE_ENV !== 'development') { window.location.replace('https://' + window.location.host + window.location.pathname) }
        })
      }
    },
    infiniteHandler ($state: any) {
      this.handleLoadProducts().then(
        (length) => {
          if (length) {
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    }
  }
})
